import React, { useState, useEffect } from 'react';
import Sidebar from 'components/ui/Sidebar';
import Icon from 'components/AppIcon';
import TodaysSchedule from './components/TodaysSchedule';
import RecentActivity from './components/RecentActivity';
import UrgentTasks from './components/UrgentTasks';
import QuickActions from './components/QuickActions';

const Dashboard = () => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);

    return () => clearInterval(timer);
  }, []);

  const keyMetrics = [
    {
      id: 1,
      title: "Active Cases",
      value: "47",
      change: "+3 this week",
      changeType: "positive",
      icon: "Briefcase",
      color: "bg-primary-50 text-primary"
    },
    {
      id: 2,
      title: "Upcoming Deadlines",
      value: "12",
      change: "Next 7 days",
      changeType: "warning",
      icon: "Clock",
      color: "bg-warning-50 text-warning-600"
    },
    {
      id: 3,
      title: "Pending Invoices",
      value: "8",
      change: "KES 2,450,000",
      changeType: "neutral",
      icon: "FileText",
      color: "bg-secondary-50 text-secondary-600"
    },
    {
      id: 4,
      title: "Monthly Revenue",
      value: "KES 8,750,000",
      change: "+15% from last month",
      changeType: "positive",
      icon: "TrendingUp",
      color: "bg-success-50 text-success-600"
    }
  ];

  const formatTime = (date) => {
    return date.toLocaleTimeString('en-KE', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
  };

  const formatDate = (date) => {
    return date.toLocaleDateString('en-KE', { 
      weekday: 'long',
      day: '2-digit',
      month: 'long',
      year: 'numeric'
    });
  };

  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      
      <div className="md:ml-64 transition-layout">
        {/* Header */}
        <header className="bg-surface border-b border-border px-6 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-heading font-bold text-text-primary">Dashboard</h1>
              <p className="text-text-secondary mt-1">
                {formatDate(currentTime)} • {formatTime(currentTime)}
              </p>
            </div>
            <div className="flex items-center space-x-4">
              <button className="relative p-2 text-text-secondary hover:text-text-primary transition-smooth">
                <Icon name="Bell" size={20} />
                <span className="absolute -top-1 -right-1 w-3 h-3 bg-accent rounded-full"></span>
              </button>
              <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
                <Icon name="User" size={16} color="white" />
              </div>
            </div>
          </div>
        </header>

        {/* Main Content */}
        <main className="p-6">
          {/* Key Metrics Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
            {keyMetrics.map((metric) => (
              <div key={metric.id} className="bg-surface rounded-lg shadow-card p-6 border border-border">
                <div className="flex items-center justify-between mb-4">
                  <div className={`w-12 h-12 rounded-lg flex items-center justify-center ${metric.color}`}>
                    <Icon name={metric.icon} size={24} />
                  </div>
                  <Icon name="MoreHorizontal" size={16} className="text-text-secondary" />
                </div>
                <div>
                  <h3 className="text-2xl font-heading font-bold text-text-primary mb-1">
                    {metric.value}
                  </h3>
                  <p className="text-sm text-text-secondary mb-2">{metric.title}</p>
                  <p className={`text-xs font-medium ${
                    metric.changeType === 'positive' ? 'text-success' :
                    metric.changeType === 'warning'? 'text-warning-600' : 'text-text-secondary'
                  }`}>
                    {metric.change}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* Main Dashboard Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-8">
            {/* Today's Schedule */}
            <div className="lg:col-span-1">
              <TodaysSchedule />
            </div>

            {/* Recent Case Activity */}
            <div className="lg:col-span-1">
              <RecentActivity />
            </div>

            {/* Urgent Tasks */}
            <div className="lg:col-span-1">
              <UrgentTasks />
            </div>
          </div>

          {/* Quick Actions */}
          <QuickActions />
        </main>
      </div>
    </div>
  );
};

export default Dashboard;